export const roleConfig = {
    '員工': 1,
    '主管': 2,
    '財務': 3,
    '經理': 4,
    '管理者': 5,
    '協理': 6,
    '維護者': 7,
};

